// 常量采⽤全⼤写单词，单词之间使⽤‘_’拼接

//媒体
export const LOGINTHEME = [{
    tabColor: 'rgba(0, 0, 0, 0.65)',                      //tab切换字体颜色
    chooseTabColor: '#72808F',                            //tab切换选中字体颜色
    inputPlaceColor: 'rgba(0, 0, 0, 0.25)',               //输入框placehold颜色
    inputIconColor: '#000000',                            //inputicon颜色
    btnBjColor: '#72808F',                                //按钮背景颜色
    btnColor: '#FFFFFF',                                  //按钮字体颜色
    iconColor: '#BDBDBD',                                 //icon颜色
    iconChooseColor: '#3296FA',                           //icon选中颜色
}]
